import { CHANGE_MAP_SCALE, CHANGE_MAP_STATE, SET_MIN_MAX_SCALE } from './constants';
import { CHANGE_MAPSCALE_SCALE } from '../mapscale/constants';
export const changeScaleAndCenter = (scale, center, componentIdent) => (dispatch, getState) => {
    const state = getState();
    const mapScaleIdent = state[componentIdent].mapScale || componentIdent;
    dispatch({
        type: CHANGE_MAP_SCALE,
        scale,
        center,
        componentIdent,
    });
    mapScaleIdent &&
        dispatch({
            type: CHANGE_MAPSCALE_SCALE,
            scale,
            componentIdent: mapScaleIdent,
        });
};
export const changeMapState = (componentIdent, mapState) => {
    return {
        type: CHANGE_MAP_STATE,
        componentIdent,
        mapState,
    };
};
export const setMinMaxScale = (componentIdent, minMaxScale) => {
    return {
        type: SET_MIN_MAX_SCALE,
        componentIdent,
        minMaxScale,
    };
};
//# sourceMappingURL=actions.js.map